import TranslationText from '@Components/Utilities/TranslationText';
import Inspection from '@Components/Detail/Inspection';

const InspectionList = (props) => {
    return (
        <div className={'inspection-list' + (props.isPrint ? ' inspection_print' : '')}>
            <h3 className='inspection-list__heading'><TranslationText tKey='sandhills.tradepubwebsite.mvc.inspectioninformation' /></h3>
            {props.Inspections.map((obj, i) =>
                <Inspection {...obj} key={i} LangID={props.LangID} isPrint={props.isPrint} />)}
        </div>
    );
};

export default InspectionList;